// Resolved collection / storage names for a festival year.
// Dancer-facing code uses `IABF` (current dancer year).
// Admin year switcher uses `iabfForYear(adminFestivalYear)`.

import {
  IABF_DANCER_YEAR,
  IABF_PEOPLE_COLLECTION,
  IABF_ACCOUNTING_PRODUCT_LINES,
  IABF_ACCOUNTING_TRANSACTIONS,
  IABF_ACCOUNTING_META,
  IABF_FESTIVAL_INVENTORY_COLLECTION,
  IABF_COSTUME_CLOSET_COLLECTION,
  IABF_CLOSET_LOANS_COLLECTION,
  IABF_DANCER_LEDGER_COLLECTION,
  col,
  dancersCollection,
  facultyCollection,
  storagePrefix,
  stripeFlow
} from './iabf-event'

/** Build the collection map for any festival year. */
export function iabfForYear (year = IABF_DANCER_YEAR) {
  const y = year
  return {
    year: y,
    people: IABF_PEOPLE_COLLECTION,

    // null for 2022–2023 (people.yearsAttended only)
    dancers: dancersCollection(y) || null,
    faculty: facultyCollection(y) || null,
    pieces: col('pieces', y),
    corpsPieces: col('corps-pieces', y),
    groupPieces: col('group-pieces', y),
    travelDetails: col('travel-details', y),
    carpools: col('carpools', y),
    classes: col('classes', y),
    config: col('config', y),
    storeItems: col('store-items', y),
    storeOrders: col('store-orders', y),
    addonServices: col('addon-services', y),
    showcaseFeedback: col('showcase-feedback', y),
    guestRegistrations: col('guest-registrations', y),
    canceledDancers: col('canceled-dancers', y),
    registrationWaitlist: col('registration-waitlist', y),
    /** Public-to-dancers introduce-yourself cards for the festival year. */
    dancerIntros: col('dancer-intros', y),
    photoshootSlots: col('photoshoot-slots', y),
    photoshootBookings: col('photoshoot-bookings', y),
    photoshootPhotos: col('photoshoot-photos', y),
    wohVideos: col('woh-videos', y),
    qohVideos: col('qoh-videos', y),
    gwVideos: col('gw-videos', y),
    becomingVideos: col('becoming-videos', y),
    jazzVideos: col('jazz-videos', y),

    accountingProductLines: IABF_ACCOUNTING_PRODUCT_LINES,
    accountingTransactions: IABF_ACCOUNTING_TRANSACTIONS,
    accountingMeta: IABF_ACCOUNTING_META,
    festivalInventory: IABF_FESTIVAL_INVENTORY_COLLECTION,
    costumeCloset: IABF_COSTUME_CLOSET_COLLECTION,
    closetLoans: IABF_CLOSET_LOANS_COLLECTION,
    dancerLedger: IABF_DANCER_LEDGER_COLLECTION,

    storage: {
      music: storagePrefix('music', y),
      store: storagePrefix('store', y),
      resources: storagePrefix('resources', y),
      setupPlan: storagePrefix('setup-plan', y),
      headshots: storagePrefix('headshots', y),
      photoshoot: storagePrefix('photoshoot', y)
    },

    flows: {
      store: stripeFlow('store', y),
      showcaseFeedback: stripeFlow('showcase-feedback', y)
    }
  }
}

/** Dancer-facing / default year collections (currently 2026). */
export const IABF = iabfForYear(IABF_DANCER_YEAR)

export { col, dancersCollection, storagePrefix, stripeFlow }
